export default "__VITE_ASSET__C0P$l2ux__"